module.exports = __webpack_public_path__ + "media/images/suppliers/vitromasterdiagnostica-385490b29128d8fcdecc1ceb018b98fa.png";